export const SITE_TITLE = 'Inersia';
